// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/ChannelLayoutPreview/styles.scss
// module id = 840
// module chunks = 0